import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertService } from './alert.service';
import { GenericData, AppRoutes, InitParams, SessionItem, eItem } from '../shared';
import { GlobalParams, Translation, CoreService, QueovalDik, ConfigModelDB, OptionalLabel, b64DecodeUnicode } from 'projects/lib-components/src/public_api';
import { PathModel } from '../shared/path.model';
import { WebStoreSettings } from './store.settings';

@Injectable()

export class StoreService {
  private sessionItemstemsList: SessionItem[];

  AppSettings: WebStoreSettings;
  InitOk: boolean;
  AppRoutes: AppRoutes;
  begin: InitParams;
  countStages: number = 0;
  countCursus: number = 0;
  configModel: ConfigModelDB;

  //#region public properties

  get AppParams(): GlobalParams {
    return this.indParam.AppParams;
  }

  set Trad(traduction: Translation) {
    this.indParam.Trad = traduction;
  }

  private pathItem: PathModel = new PathModel();
  get PathItem(): PathModel {
    return this.pathItem;
  }

  //#endregion

  constructor(
    private indParam: CoreService,
    private alert: AlertService,
    protected domSanitizer: DomSanitizer,
    protected router: Router,
  ) {
    this.AppRoutes = new AppRoutes();
    this.InitOk = this.initStore();
    if (!this.InitOk) {
      console.error('Error returning querystring data for authentication');
    }
  }

  closeModal(): void {
    this.alert.closeModal('commonalert');
  }

  showSplash(view: boolean): void {
    this.alert.showSplash(view);
  }

  showAlert(message: string): void {
    this.alert.showAlert(message);
  }

  warning(message: string): void {
    this.alert.showWarningToast(message);
  }

  getCustomLabel(targetPage: string, key: string): string {
    if (this.configModel && this.configModel.CustomLabels && this.configModel.CustomLabels.length > 0) {
      const aa: OptionalLabel[] = this.configModel.CustomLabels.filter((e: OptionalLabel): boolean => e.TargetPage === targetPage);
      const bb: OptionalLabel[] = aa.filter((e: OptionalLabel): boolean => e.Key === key);
      const lb: OptionalLabel[] = this.configModel.CustomLabels.filter((e: OptionalLabel): boolean => e.TargetPage === targetPage && e.Key === key);
      if (lb.length > 0 && this.indParam.AppParams.culture !== '') {
        const lbl: QueovalDik[] = lb[0].Label.filter((e: QueovalDik): boolean => e.key === this.indParam.AppParams.culture);
        if (lbl.length > 0) {
          return lbl[0].value;
        }
      }
      //else return this.getLabel(key);
    }
    return this.indParam.getTrad(key);
  }

  getTrad(key: string): string {
    return this.indParam.getTrad(key);
  }

  getImgUrl(imgUrl: string): string {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(imgUrl) as string;
  }

  openPage(pageCode: string): void {
    switch (pageCode) {
      case 'HME': this.router.navigateByUrl(`${this.AppRoutes.HOME}/${this.indParam && this.indParam.AppParams && this.indParam.AppParams.culture ? this.indParam.AppParams.culture : 'fr-FR'}`); break;
      case 'CYC': this.router.navigateByUrl(this.AppRoutes.CYCLESLIST); break;
      case 'ELE': this.router.navigateByUrl(this.AppRoutes.ELEARNINGLIST); break;
      case 'SES': this.router.navigateByUrl(this.AppRoutes.STAGESLIST); break;
      case 'CTL': this.router.navigateByUrl(this.AppRoutes.CATALOGS); break;
      case 'ADMCAT': this.router.navigateByUrl(this.AppRoutes.ADMINCATALOGS); break;
      case 'ADMCYC': this.router.navigateByUrl(this.AppRoutes.ADMINCYCLES); break;
      //////case 'ADMCNF': this.router.navigateByUrl(this.appRoutes.ADMINCONFIG); break;
      case 'PRD': this.router.navigateByUrl(this.AppRoutes.PRODUCTS); break;
      case 'PRDLNK': this.router.navigateByUrl(this.AppRoutes.PRODUCTLINK); break;
      default:
        this.router.navigateByUrl(pageCode);
        break;
    }
  }

  convertList<T>(list: T[], period: number): GenericData<T>[] {
    const result: GenericData<T>[] = [];
    let el: GenericData<T>;
    let count: number = 0;

    for (let n: number = 0; n < list.length; n++) {
      if (n % period) {
        result[count - 1].listFils.push(list[n]);

      } else {
        if (n % period === 0) {
          el = new GenericData<T>();
          el.listFils.push(list[n]);
          result.push(el);
          count++;
          //result;
        }
      }
    }

    return result;
  }

  convertGenericData<T>(list: GenericData<T>[]): T[] {
    const result: T[] = [];

    for (let n: number = 0; n < list.length; n++) {
      for (let m: number = 0; m < list[n].listFils.length; m++) {
        result.push(list[n].listFils[m]);
      }
    }

    return result;
  }

  traceData(text: string): void {
    console.log(text);
  }

  isBrowserMS(): boolean {
    if (/MSIE 10/i.test(navigator.userAgent)) {
      //window.alert('This is internet explorer 10');
      return true;
    }
    if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
      //window.alert('This is internet explorer 9 or 11');
      return true;
    }
    if (/Edge\/\d./i.test(navigator.userAgent)) {
      //window.alert('This is Microsoft Edge');
      return true;
    }
    return false;
  }

  stockData(key: string, value: string): void {
    this.indParam.stockData(key, value);
  }

  getStocked(key: string, remove: boolean = false): string {
    return this.indParam.getStocked(key, remove);
  }

  AddDataSession(item: SessionItem): void {
    this.sessionItemstemsList.push(item);
  }

  GetDataSession(itemType: eItem): SessionItem | null {
    const r: SessionItem[] = this.sessionItemstemsList.filter((e: SessionItem) => e.type === itemType);
    return r && r.length > 0 ? r[0] : null;
  }

  ClearDataSession(): void {
    this.sessionItemstemsList = [];
  }

  RemoveSession(itemType: eItem): void {
    let index: number = -1;
    for (let n: number = 0; n < this.sessionItemstemsList.length; n++) {
      if (this.sessionItemstemsList[n].type === itemType) {
        index = n;
      }
    }
    if (index > -1)
      this.sessionItemstemsList.splice(index, 1);
  }

  private initStore(): boolean {
    let qs: string | null = '';
    console.log(window.location.href);
    if (window.location.search) {
      qs = window.location.search;
      localStorage.setItem('urlParams', window.location.search);
    } else {
      qs = localStorage.getItem('urlParams');
    }

    if (qs && qs !== '') {
      const urlParams: any = qs.split(/[&||?]/).filter(function (x: string): boolean { return x.indexOf('=') > -1; })
        .map(function (x: string): string[] { return x.split(/=/); })
        .map(function (x: string[]): string[] { x[1] = x[1].replace(/\+/g, ' '); return x; })
        .reduce(function (acc: any, current: any): any { acc[current[0]] = current[1]; return acc; }, {});

      this.begin = new InitParams();
      if (urlParams) {
        if (urlParams.info && urlParams.info !== '') {
          // MIXED MODE
          this.begin.access = 'MIXED';
          this.begin.mode = 'MIXED';
          this.begin.sample = urlParams.info;
          this.begin.siteUrl = urlParams.st ? urlParams.st : '';
          this.begin.apiUrl = urlParams.wba ? b64DecodeUnicode(urlParams.wba) : '';

          this.begin.goToCycleList = urlParams.cursus ? urlParams.cursus : '';
          this.begin.goToStageList = urlParams.stages ? urlParams.stages : '';
          this.begin.goToCatalogueList = urlParams.catalogues ? urlParams.catalogues : '';

          this.begin.goToCategories_ByCatalogueID = urlParams.ctl ? urlParams.ctl : '';
          this.begin.goToProducts_ByCategorieID = urlParams.cte ? urlParams.cte : '';

          this.begin.goToProduct_ByID = urlParams.pr ? urlParams.pr : '';
          this.begin.goToCycle_ByID = urlParams.crs ? urlParams.crs : '';
          this.begin.goToStage_ByID = urlParams.stg ? urlParams.stg : '';

          this.begin.goToProductForm = urlParams.prfrm ? urlParams.prfrm : '';
          this.begin.goToCycleForm = urlParams.crsfrm ? urlParams.crsfrm : '';
          this.begin.goToStageForm = urlParams.stgfrm ? urlParams.stgfrm : '';

          this.begin.isAdmin = urlParams.admin && urlParams.admin === '1' || false;
        } else {
          // PORTAIL MODE
          this.begin.access = 'PORTAIL';
          this.begin.mode = 'PORTAIL';
          this.begin.sample = urlParams.tk ? urlParams.tk : '';
          this.begin.siteUrl = 'portail';
          this.begin.apiUrl = urlParams.wba ? b64DecodeUnicode(urlParams.wba) : '';

          this.begin.goToCycleList = '';
          this.begin.goToStageList = '';
          this.begin.goToCatalogueList = '';
          this.begin.goToCategories_ByCatalogueID = '';
          this.begin.goToProducts_ByCategorieID = '';
          this.begin.goToProduct_ByID = '';
          this.begin.goToCycle_ByID = '';
          this.begin.goToStage_ByID = '';

          this.begin.isAdmin = urlParams.admin && urlParams.admin === '1' || false;
        }
      }

      if (this.begin.access !== 'EMPTY' && this.begin.apiUrl !== '') {
        this.sessionItemstemsList = [];
        return true;
      }
    }

    return false;
  }





}
